<template>
  <div v-if="eligibleCampaign" class="prakerja-gamification" data-testid="prakerja-gamification">
    <img
      :src="bannerTrxMweb"
      alt="gamification-banner"
      width="100%"
      height="66"
      class="prakerja-gamification__bg"
      data-testid="gamification-banner"
    />
    <div class="prakerja-gamification__body" data-testid="gamification-body">
      <div>
        <BlTextAv class="prakerja-gamification__text" variation="body-14" weight="bold" data-testid="gamification-title">
          Selesaikan kelas, dapat saldo e-wallet
        </BlTextAv>
        <BlTextAv class="prakerja-gamification__text mt-4" variation="caption-12" data-testid="gamification-subtitle">
          Gercep ikutin misi agar kamu bisa ambil hadiah
        </BlTextAv>
      </div>
      <BlButtonAv
        variation="naked"
        class="prakerja-gamification__btn"
        data-testid="gamification-button"
        size="small"
        @click="onClickGamificationHomePage"
      >
        <IcoChevronRightMinor slot="icon" color="#332F9E" />
      </BlButtonAv>
    </div>
  </div>
</template>
<script>
import {BlButtonAv, BlTextAv} from '@bukalapak/bazaar-mweb-latest';
import {IcoChevronRightMinor} from '@bukalapak/bazaar-visual-next';
import prakerjaGamification from 'src/shared/mixins/prakerja-gamification';
import {TRACKER_EVENT_VP_PRAKERJA_GAMIFICATION_ENTRYPOINT} from '../../config/tracker-events';
import trackerGenerator from '../../mixins/tracker-generator';

export default {
  name: 'PrakerjaGamificationTransaction',
  components: {
    BlButtonAv,
    IcoChevronRightMinor,
    BlTextAv,
  },
  mixins: [prakerjaGamification, trackerGenerator],
  computed: {
    bannerTrxMweb() {
      return this.$publicUrl('images/kartu-prakerja/prakerja-gamif-trx-mweb.png');
    },
  },
  watch: {
    eligibleCampaign(value) {
      if (value) {
        this.trackViewGamification();
      }
    },
  },
  methods: {
    onClickGamificationHomePage() {
      this.mixinSendTracker(TRACKER_EVENT_VP_PRAKERJA_GAMIFICATION_ENTRYPOINT, {
        source: 'coupon_detail_page',
        action: 'click_gamification_entry_point',
      });
      this.navigateToGamificationHomePage();
    },
    trackViewGamification() {
      this.mixinSendTracker(TRACKER_EVENT_VP_PRAKERJA_GAMIFICATION_ENTRYPOINT, {
        source: 'coupon_detail_page',
        action: 'impress_gamification_entry_point',
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.prakerja-gamification {
  display: flex;
  min-height: 66px;
  position: relative;
  .prakerja-gamification__bg {
    position: absolute;
    z-index: 0;
  }
  .prakerja-gamification__body {
    position: relative;
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
  }
  .prakerja-gamification__text {
    color: #332f9e;
  }
  .prakerja-gamification__btn {
    border-radius: 100px;
    border: 2px solid #332f9e;
  }
}
</style>
